import slideEarly from "@/assets/images/kids/image.png";
import slideStructured from "@/assets/images/kids/image1.png";
import slideAdvanced from "@/assets/images/kids/image2.png";

export const KIDS_STORE_PATH = "/ipromiseafrica/kids";
export const KIDS_STORE_ROUTE = "KidsStore";
export const KIDS_DETAIL_ROUTE = "KidsProductDetail";
export const KIDS_CART_PATH = `${KIDS_STORE_PATH}/cart`;
export const KIDS_CART_ROUTE = "KidsCart";

export const KIDS_API = {
  list: "/api/kids/products",
  detail: (slug) => `/api/kids/products/${encodeURIComponent(slug)}`,
  related: (slug) => `/api/kids/products/${encodeURIComponent(slug)}/related`,
  orderCreation: "/api/kids/orders/order-creation",
};

export const KIDS_HERO_SLIDES = [
  {
    id: "early-movement",
    stage: 1,
    title: "Early Movement & Motor Skills",
    subtitle: "Toys, ride-ons, and play surfaces for first steps into active life.",
    image: slideEarly,
    alt: "Kids sports gear for early movement and motor skills development",
  },
  {
    id: "structured-play",
    stage: 2,
    title: "Structured Play & Basic Sport",
    subtitle: "Starter equipment and outdoor play for growing confidence in sport.",
    image: slideStructured,
    alt: "Kids equipment for structured play and basic sports",
  },
  {
    id: "advanced-play",
    stage: 3,
    title: "Advanced Play & Training",
    subtitle: "Training gear, kits, and sport-specific tools for committed young athletes.",
    image: slideAdvanced,
    alt: "Advanced kids sports play and training equipment",
  },
];
